import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createRoleSuccess } from 'src/app/pages/add-role/state/add-role.actions';
import { saveRoleDetailSuccess } from 'src/app/pages/role-details/state/role-detail.actions';
import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { filterNamedOption } from '../../select/shared/filter-named-option';
import { roleOptionActions } from './role-option.actions';

export const roleOptionFeatureKey = 'roleOptions';

export type RoleOptionState = EagerSelectState<RoleOption>;

const adapter = createEagerSelectAdapter<RoleOptionState, RoleOption>({
   featureKey: roleOptionFeatureKey,
   selectId: (role: RoleOption) => {
      return role.roleId;
   },
});

export const roleOptionSelectors = adapter.getSelectors(filterNamedOption);

const initialState = adapter.getInitialState();

export const roleOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   roleOptionActions.search,
   roleOptionActions.searchReset,
   roleOptionActions.loadFromApi,
   roleOptionActions.loadFromApiSuccess,
   roleOptionActions.loadFromApiFailure,
   null,
   on(createRoleSuccess, saveRoleDetailSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);
